import React, { useEffect, useState } from 'react';
import {
  DatePicker, Table, Input, Radio, Checkbox,
} from 'antd';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH, faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import * as _ from 'lodash';
import moment from 'moment';
import { injectIntl } from 'react-intl';

import { elementType } from 'prop-types';
import {
  columnsRx, columnsPrescription, columnsDistance, columnsVisualSharp,
} from './eyeChartTables';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import ShowIf from '../../../shared/components/dataDisplay/ShowIf';
import { Flex } from '../../../shared/components';
import ReadOnly from '../../../shared/components/dataEntry/ReadOnly';
import { useScrollToError } from '../../../../hooks/useScrollToError';
import { requiredRuleEjeCilindro } from '../newPatient/rules';


interface eyeChartContentProps{
  create: boolean,
  watch: boolean,
  hookForms: any,
  setDrawerAttended: any,
  setDrawerPrescriber: any,
  attendedStr: string,
  prescriberStr: string,
  setPrescriberStr: any,
  setAttendedStr: any,
  intl: any
}

function EyeChartContent({
  create, watch, hookForms, setDrawerAttended, setDrawerPrescriber, attendedStr, prescriberStr, setAttendedStr, setPrescriberStr, intl,
}:eyeChartContentProps) {
  const { isTablet, isDesktop } = useBreakpoint();
  const eyeChartSelected = useSelector((state: any) => state.fichaOptometricaWorkspace.graduacionSelected);
  const loadingPrescripcion = useSelector((state: any) => state.sagas.GET_GRADUACION?.running);
  const usuarios = useSelector((state: any) => state.fichaOptometricaWorkspace.usuarios);
  const prescriptores = useSelector((state: any) => state.fichaOptometricaWorkspace.prescriptores);
  const opcion_agudeza_visual = useSelector((state: any) => state.auth.permisos.configuracion.agudeza_visual_fraccionaria);
  const [codigo, setCodigo] = useState('');
  const [tienda, setTienda] = useState('');
  const [tieneEsferasPrescripcionDerecha, setTieneEsferasPrescripcionDerecha] = useState(false);
  const [tieneEsferasPrescripcionIzquierda, setTieneEsferasPrescripcionIzquierda] = useState(false);
  const [tieneEsferasRXInicialDerecha, setTieneEsferasRXInicialDerecha] = useState(false);
  const [tieneEsferasRXInicialIzquierda, setTieneEsferasRXInicialIzquierda] = useState(false);

  const {
    register, setValue, control, getValues, formState: {errors}, trigger, clearErrors
  } = hookForms;
  const tiendaCreateId = useSelector((state: any) => state.auth.user.user_info.tienda_id);
  const tiendas = useSelector((state: any) => state.core.tiendas);
  const tiendaCreate = create ? tiendas.find((e:any) => e.id === tiendaCreateId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const tieneVentaAsociada = !create && eyeChartSelected.venta_asociada;

  const requiredRule = (param: string) => ({
    required: {
      value: true,
      message: intl.formatMessage({ id: 'pacientes.generic.errors.introduce' }, {
        param: intl.formatMessage({ id: `pacientes.generic.titles.${param}` }),
      }),
    },
  });

  const cellRegister = ((elem: HTMLInputElement | HTMLTextAreaElement | null) => {
    if (watch && elem) elem.disabled = true;
    register(elem);
  });


  useEffect(() => {
    register('prescripcion.ojo_derecho.eje', requiredRuleEjeCilindro(intl, 'prescripcion.ojo_derecho.cilindro','prescripcion.ojo_derecho.eje', control, clearErrors));
    register('prescripcion.ojo_izquierdo.eje', requiredRuleEjeCilindro(intl, 'prescripcion.ojo_izquierdo.cilindro','prescripcion.ojo_izquierdo.eje', control, clearErrors));
    register('prescripcion.ojo_derecho.cilindro', requiredRuleEjeCilindro(intl, 'prescripcion.ojo_derecho.eje','prescripcion.ojo_derecho.cilindro', control, clearErrors));
    register('prescripcion.ojo_izquierdo.cilindro', requiredRuleEjeCilindro(intl, 'prescripcion.ojo_izquierdo.eje','prescripcion.ojo_izquierdo.cilindro', control, clearErrors));

    register('rx_inicial.ojo_derecho.eje', requiredRuleEjeCilindro(intl, 'rx_inicial.ojo_derecho.cilindro','rx_inicial.ojo_derecho.eje', control, clearErrors));
    register('rx_inicial.ojo_izquierdo.eje', requiredRuleEjeCilindro(intl, 'rx_inicial.ojo_izquierdo.cilindro','rx_inicial.ojo_izquierdo.eje', control, clearErrors));
    register('rx_inicial.ojo_derecho.cilindro', requiredRuleEjeCilindro(intl, 'rx_inicial.ojo_derecho.eje','rx_inicial.ojo_derecho.cilindro', control, clearErrors));
    register('rx_inicial.ojo_izquierdo.cilindro', requiredRuleEjeCilindro(intl, 'rx_inicial.ojo_izquierdo.eje','rx_inicial.ojo_izquierdo.cilindro', control, clearErrors));
    
  }, [register]);

  useEffect(() => {
    if (!create && Object.entries(eyeChartSelected).length > 0 && usuarios.length > 0 && !loadingPrescripcion) {
      setTieneEsferasPrescripcionDerecha(!create && eyeChartSelected.prescripcion && eyeChartSelected.prescripcion.ojo_derecho && (eyeChartSelected.prescripcion.ojo_derecho.esfera_cerca || eyeChartSelected.prescripcion.ojo_derecho.esfera_lejos));
      setTieneEsferasPrescripcionIzquierda(!create && eyeChartSelected.prescripcion && eyeChartSelected.prescripcion.ojo_izquierdo && (eyeChartSelected.prescripcion.ojo_izquierdo.esfera_cerca || eyeChartSelected.prescripcion.ojo_izquierdo.esfera_lejos));
      setTieneEsferasRXInicialDerecha(!create && eyeChartSelected.rx_inicial && eyeChartSelected.rx_inicial.ojo_derecho && (eyeChartSelected.rx_inicial.ojo_derecho.esfera_cerca || eyeChartSelected.rx_inicial.ojo_derecho.esfera_lejos));
      setTieneEsferasRXInicialIzquierda(!create && eyeChartSelected.rx_inicial && eyeChartSelected.rx_inicial.ojo_izquierdo && (eyeChartSelected.rx_inicial.ojo_izquierdo.esfera_cerca || eyeChartSelected.rx_inicial.ojo_izquierdo.esfera_lejos));

      const {
        codigo,
        nombre_tienda,
        historial,
        observacion_pupilas,
        ...graduacion
      } = eyeChartSelected;
      setCodigo(codigo);
      setTienda(nombre_tienda);
      const formValues = getValues();
      Object.entries(graduacion).forEach(([key, value]) => {
        switch (true) {
          case (key === 'fecha' || key === 'fecha_proxima_graduacion'):
            if (!graduacion[key]) {
              // @ts-ignore
              setValue(key, moment());
            } else {
              // @ts-ignore
              setValue(key, moment(graduacion[key], 'DD/MM/YYYY hh:mm:ss'));
            }
            break;
          case (key === 'atendido_por_id'):
            // @ts-ignore
            setValue(key, graduacion[key]);
            if (usuarios.length > 0) {
              const name = usuarios.find((usuario: any) => usuario.id == graduacion[key])?.nombreCompleto;
              setAttendedStr(name);
            }
            break;
          case (key === 'prescriptor_id'):
            // @ts-ignore
            setValue(key, graduacion[key]);
            if (prescriptores.length > 0) {
              const name = prescriptores.find((usuario: any) => usuario.id == graduacion[key])?.nombreCompleto;
              setPrescriberStr(name);
            }
            break;
          default:
            setValue(key, graduacion[key] || '');
        }
      });
    }
  }, [eyeChartSelected, usuarios, prescriptores]);

  const initialRx = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.eje"
        ref={cellRegister}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.cilindro"
        ref={cellRegister}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.esfera_lejos"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_derecho', 'rx_inicial')}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_derecho', 'rx_inicial')}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.esfera_cerca"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_derecho', 'rx_inicial')}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.adicion"
        onChange={() => calcularEsfera('ojo_derecho', 'rx_inicial')}
        ref={cellRegister}
        disabled={!tieneEsferasRXInicialDerecha}
      />,
      avcc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="rx_inicial.ojo_derecho.avcc"
        ref={cellRegister}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.eje"
        ref={cellRegister}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.cilindro"
        ref={cellRegister}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.esfera_lejos"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_izquierdo', 'rx_inicial')}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_izquierdo', 'rx_inicial')}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.esfera_cerca"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_izquierdo', 'rx_inicial')}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.adicion"
        ref={cellRegister}
        onChange={() => calcularEsfera('ojo_izquierdo', 'rx_inicial')}
        disabled={!tieneEsferasRXInicialIzquierda}
      />,
      avcc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="rx_inicial.ojo_izquierdo.avcc"
        ref={cellRegister}
      />,
    },
  ];

  const prescription = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.eje"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.cilindro"
        ref={cellRegister}
        disabled={tieneVentaAsociada}

      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.esfera_lejos"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_derecho', 'prescripcion')}
        disabled={tieneVentaAsociada}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_derecho', 'prescripcion')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.esfera_cerca"
        ref={cellRegister}
        onChange={() => calcularAdicion('ojo_derecho', 'prescripcion')}
        disabled={tieneVentaAsociada}
      />,
      esfMedia: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.esfera_media"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="prescripcion.ojo_derecho.adicion"
        ref={cellRegister}
        onChange={() => calcularEsfera('ojo_derecho', 'prescripcion')}
        disabled={tieneVentaAsociada || !tieneEsferasPrescripcionDerecha}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.eje"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.cilindro"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.esfera_lejos"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
        onChange={() => calcularAdicion('ojo_izquierdo', 'prescripcion')}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_izquierdo', 'prescripcion')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.esfera_cerca"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
        onChange={() => calcularAdicion('ojo_izquierdo', 'prescripcion')}
      />,
      esfMedia: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.esfera_media"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="prescripcion.ojo_izquierdo.adicion"
        ref={cellRegister}
        disabled={tieneVentaAsociada || !tieneEsferasPrescripcionIzquierda}
        onChange={() => calcularEsfera('ojo_izquierdo', 'prescripcion')}
      />,
    },
  ];

  const visualSharpData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      sc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_derecho.sc"
        ref={cellRegister}
      />,
      cc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_derecho.cc"
        ref={cellRegister}
      />,
      cerca: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_derecho.cerca"
        ref={cellRegister}
      />,
      visualSharpBino: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.binocular"
        ref={cellRegister}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      sc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_izquierdo.sc"
        ref={cellRegister}
      />,
      cc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_izquierdo.cc"
        ref={cellRegister}
      />,
      cerca: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        className="tableInputs"
        name="agudeza_visual.ojo_izquierdo.cerca"
        ref={cellRegister}
      />,
    },
  ];

  const distance = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      dnpl: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="distancias.ojo_derecho.lejos"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      dnpc: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="distancias.ojo_derecho.cerca"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      dnpl: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="distancias.ojo_izquierdo.lejos"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
      dnpc: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        className="tableInputs"
        name="distancias.ojo_izquierdo.cerca"
        ref={cellRegister}
        disabled={tieneVentaAsociada}
      />,
    },
  ];

  function disabledDate(current:any) {
    return current && current < moment().add(-1, 'day');
  }

  const getPrescriptionErrors = () => {
    if (errors.prescripcion) return true;
    return false;
  };
  const getRxInitialErrors = () => {
    if (errors.rx_inicial) return true;
    return false;
  };
  const getAgudezaErrors = () => {
    if (errors.agudeza_visual) return true;
    return false;
  };
  const getDistanceErrors = () => {
    if (errors.distancias) return true;
    return false;
  };
  const getMotivoErrors = () => {
    if (errors.motivo) return true;
    return false;
  };

  function setTwoNumberDecimal(value: any, type:string) {
    if (type === 'axis') {
      if (parseFloat(value) < 0 || parseFloat(value) > 359 || parseFloat(value) % 1 !== 0) return '';
      if (value.charAt(value.length - 1) === 'º') return value;
      return `${value}º`;
    }
    if (type === 'sign') {
      if (value.charAt(0) !== '+' && value.charAt(0) !== '-') {
        if (parseFloat(value) % 0.25 !== 0 || parseFloat(value) > 50.0 || parseFloat(value) < -50.0) return '';
        return `+${parseFloat(value).toFixed(2)}`;
      }
      if (value.charAt(0) === '+' || value.charAt(0) === '-') {
        const currentSign = value.charAt(0);
        const sub = value.substring(1);
        if (parseFloat(sub) % 0.25 !== 0 || parseFloat(value) > 50.0 || parseFloat(value) < -50.0) return '';
        return currentSign + parseFloat(sub).toFixed(2);
      }
    } else {
      return parseFloat(value).toFixed(2);
    }
  }
  function setNumberFractional(value:any) {
    const cadena = value.split('/');
    let cadenaFinal = '';
    if (cadena.length == 2) {
      cadena.forEach((element:any) => {
        if (element.length > 2) {
          if (cadenaFinal == '') {
            cadenaFinal = `${element.substr(0, 2)}/`;
          } else {
            cadenaFinal += element.substr(0, 2);
          }
        }
      });
    }
    return cadenaFinal;
  }
  function setFormatoAgudezaVisual(e:any) {
    if (opcion_agudeza_visual == 'S') {
      e.target.value = setNumberFractional(e.target.value);
    } else {
      setTwoNumberDecimalBlur(e, '');
    }
  }
  function setTwoNumberDecimalBlur(e: any, type:string) {
    const regEx = /^[\d\(\)\-+.º]+$/m;
    if (regEx.test(e.target.value) === false) {
      e.target.value = '';
      return e.target.value;
    }
    if (e.target.value === '') return;
    e.target.value = setTwoNumberDecimal(e.target.value, type);
  }
  function setTwoNumberDecimalBlurEsferaLejos(e: any, type:string) {
    const regEx = /^[\d\(\)\-+.º]+$/m;
    if (regEx.test(e.target.value) === false) {
      if (e.target.value == 'C' || e.target.value == 'N') {
        return e.target.value;
      }
      e.target.value = '';
      return e.target.value;
    }
    if (e.target.value === '') return;
    e.target.value = setTwoNumberDecimal(e.target.value, type);
  }
  function setTwoNumberDecimalBlurEsfCerca(e:any, ojo: string, type: string) {
    const values = getValues();
    const datosOjo = ojo === 'ojo_derecho' ? values[type]?.ojo_derecho : values[type]?.ojo_izquierdo;
    if (!datosOjo) return;
    const { esfera_lejos } = datosOjo;
    const numberEsfLejos = parseFloat(esfera_lejos);
    if (numberEsfLejos > e.target.value && e.target.value != '') {
      e.target.value = numberEsfLejos;
      setTwoNumberDecimalBlur(e, 'sign');
    } else {
      setTwoNumberDecimalBlur(e, 'sign');
    }
  }
  function calcularEsfera(ojo: string, type:string) {
    const values = getValues();
    if (!values[type]) return;
    const datosOjo = ojo === 'ojo_derecho' ? values[type]?.ojo_derecho : values[type]?.ojo_izquierdo;
    if (!datosOjo) return;
    const { adicion, esfera_cerca, esfera_lejos } = datosOjo;
    const numberAdicion = parseFloat(adicion);
    const numberEsfLejos = parseFloat(esfera_lejos);
    const numberEsfCerca = parseFloat(esfera_cerca);
    if (numberAdicion) {
      if (numberEsfLejos) {
        setValue(`${type}.${ojo}.esfera_cerca`, setTwoNumberDecimal((numberEsfLejos + numberAdicion).toString(), 'sign'));
      }
      if (!numberEsfLejos && numberEsfCerca) {
        const esfLejosCalc = (numberEsfCerca - numberAdicion);
        if (esfLejosCalc < 0) {
          setValue(`${type}.${ojo}.esfera_lejos`, setTwoNumberDecimal('0', 'sign'));
          setValue(`${type}.${ojo}.esfera_cerca`, setTwoNumberDecimal(numberAdicion.toString(), 'sign'));
        } else {
          setValue(`${type}.${ojo}.esfera_lejos`, setTwoNumberDecimal(esfLejosCalc.toString(), 'sign'));
        }
      }
    }
  }
  function calcularAdicion(ojo: string, type:string) {
    const values = getValues();
    if (!values[type]) return;
    const datosOjo = ojo === 'ojo_derecho' ? values[type]?.ojo_derecho : values[type]?.ojo_izquierdo;
    if (!datosOjo) return;
    const { adicion, esfera_cerca, esfera_lejos } = datosOjo;
    if (esfera_lejos == 'N' || esfera_cerca == 'N' || esfera_lejos == 'C' || esfera_cerca == 'C') {
      if (ojo === 'ojo_izquierdo') {
        if (type === 'prescripcion') {
          setTieneEsferasPrescripcionIzquierda(esfera_lejos || esfera_cerca);
        } else if (type === 'rx_inicial') {
          setTieneEsferasRXInicialIzquierda(esfera_lejos || esfera_cerca);
        }
      } else if (type === 'prescripcion') {
        setTieneEsferasPrescripcionDerecha(esfera_lejos || esfera_cerca);
      } else if (type === 'rx_inicial') {
        setTieneEsferasRXInicialDerecha(esfera_lejos || esfera_cerca);
      }
    } else {
      const numberEsfCerca = parseFloat(esfera_cerca);
      const numberEsfLejos = parseFloat(esfera_lejos);
      if (esfera_lejos && esfera_cerca) {
        if (
          numberEsfCerca > numberEsfLejos
          && setTwoNumberDecimal((numberEsfCerca - numberEsfLejos).toString(), '') > 0
          && setTwoNumberDecimal((numberEsfCerca - numberEsfLejos).toString(), '') < 9.99
        ) {
          setValue(`${type}.${ojo}.adicion`, setTwoNumberDecimal((numberEsfCerca - numberEsfLejos).toString(), ''));
        } else {
          setValue(`${type}.${ojo}.adicion`, '');
        }
      } else {
        setValue(`${type}.${ojo}.adicion`, '');
      }
      if (ojo === 'ojo_izquierdo') {
        if (type === 'prescripcion') {
          setTieneEsferasPrescripcionIzquierda(esfera_lejos || esfera_cerca);
        } else if (type === 'rx_inicial') {
          setTieneEsferasRXInicialIzquierda(esfera_lejos || esfera_cerca);
        }
      } else if (type === 'prescripcion') {
        setTieneEsferasPrescripcionDerecha(esfera_lejos || esfera_cerca);
      } else if (type === 'rx_inicial') {
        setTieneEsferasRXInicialDerecha(esfera_lejos || esfera_cerca);
      }
    }
  }

  function getTraspuesta() {
    const { prescripcion } = getValues();
    const { ojo_derecho, ojo_izquierdo } = prescripcion;

    if (ojo_derecho.eje != '' && ojo_derecho.cilindro != '') {
      if ((parseFloat(ojo_derecho.eje) >= 90) && (parseFloat(ojo_derecho.eje) <= 180)) {
        setValue('prescripcion.ojo_derecho.eje', setTwoNumberDecimal((parseFloat(ojo_derecho.eje) - 90).toString(), 'axis'));
      } else {
        setValue('prescripcion.ojo_derecho.eje', setTwoNumberDecimal((parseFloat(ojo_derecho.eje) + 90).toString(), 'axis'));
      }
    }
    if (ojo_izquierdo.eje != '' && ojo_izquierdo.cilindro != '') {
      if ((parseFloat(ojo_izquierdo.eje) >= 90) && (parseFloat(ojo_izquierdo.eje) <= 180)) {
        setValue('prescripcion.ojo_izquierdo.eje', setTwoNumberDecimal((parseFloat(ojo_izquierdo.eje) - 90).toString(), 'axis'));
      } else {
        setValue('prescripcion.ojo_izquierdo.eje', setTwoNumberDecimal((parseFloat(ojo_izquierdo.eje) + 90).toString(), 'axis'));
      }
    }
    if(ojo_derecho.eje != '' && ojo_derecho.cilindro != ''){
      if (isNaN(parseFloat(ojo_derecho.esfera_lejos))) {
        setValue('prescripcion.ojo_derecho.esfera_lejos', setTwoNumberDecimal(parseFloat(ojo_derecho.cilindro).toString(), 'sign'));
      } else {
        setValue('prescripcion.ojo_derecho.esfera_lejos', setTwoNumberDecimal((parseFloat(ojo_derecho.esfera_lejos) + parseFloat(ojo_derecho.cilindro)).toString(), 'sign'));
      }
    }
    if(ojo_izquierdo.eje != '' && ojo_izquierdo.cilindro != ''){
      if (isNaN(parseFloat(ojo_izquierdo.esfera_lejos))) {
        setValue('prescripcion.ojo_izquierdo.esfera_lejos', setTwoNumberDecimal(parseFloat(ojo_izquierdo.cilindro).toString(), 'sign'));
      } else {
        setValue('prescripcion.ojo_izquierdo.esfera_lejos', setTwoNumberDecimal((parseFloat(ojo_izquierdo.esfera_lejos) + parseFloat(ojo_izquierdo.cilindro)).toString(), 'sign'));
      }
    }

    if (ojo_derecho.adicion != '' && ojo_derecho.cilindro != '' && ojo_derecho.eje != '') {
      if (isNaN(parseFloat(ojo_derecho.esfera_cerca))) {
        setValue('prescripcion.ojo_derecho.esfera_cerca', setTwoNumberDecimal(parseFloat(ojo_derecho.cilindro).toString(), 'sign'));
      } else {
        setValue('prescripcion.ojo_derecho.esfera_cerca', setTwoNumberDecimal((parseFloat(ojo_derecho.esfera_cerca) + parseFloat(ojo_derecho.cilindro)).toString(), 'sign'));
      }
    }
    if (ojo_izquierdo.adicion != '' && ojo_izquierdo.cilindro != '' && ojo_izquierdo.eje != '') {
      if (isNaN(parseFloat(ojo_izquierdo.esfera_cerca))) {
        setValue('prescripcion.ojo_izquierdo.esfera_cerca', setTwoNumberDecimal(parseFloat(ojo_izquierdo.cilindro).toString(), 'sign'));
      } else {
        setValue('prescripcion.ojo_izquierdo.esfera_cerca', setTwoNumberDecimal((parseFloat(ojo_izquierdo.esfera_cerca) + parseFloat(ojo_izquierdo.cilindro)).toString(), 'sign'));
      }
    }
    if (ojo_derecho.cilindro != '' && ojo_derecho.eje != '') {
      setValue('prescripcion.ojo_derecho.cilindro', setTwoNumberDecimal((parseFloat(ojo_derecho.cilindro) * -1.0).toString(), 'sign'));
    }
    if (ojo_izquierdo.cilindro != '' && ojo_izquierdo.eje != '') {
      setValue('prescripcion.ojo_izquierdo.cilindro', setTwoNumberDecimal((parseFloat(ojo_izquierdo.cilindro) * -1.0).toString(), 'sign'));
    }
  }
  return (
    <>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>{intl.formatMessage({ id: 'pacientes.eye_chart.grad_data' })}</h3>
        </div>

        <div className="contact">
          <ShowIf condition={!create}>
            <div className="margin-right flexCol">
              <p>{intl.formatMessage({ id: 'pacientes.eye_chart.code' })}</p>
              <div className="inputMarginTop" style={{ color: '#3E3E3C' }}>
                <ReadOnly condition={watch}>
                  <span>{codigo}</span>
                </ReadOnly>
              </div>
            </div>
          </ShowIf>
          <div className={create ? 'flexCol' : 'margin-left flexCol'}>
            <p>{intl.formatMessage({ id: 'pacientes.eye_chart.store' })}</p>
            <div className="inputMarginTop" style={{ color: '#3E3E3C' }}>
              <ReadOnly condition={watch}>
                <span>{tienda || tiendaCreateName}</span>
              </ReadOnly>
            </div>
          </div>
        </div>

        <div className="contact" style={{ paddingTop: '8px' }}>
          <div className="margin-right flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.eye_chart.date' })}</p>
            <div className="inputMarginTop">
              <ReadOnly condition={watch}>
                <Controller
                  name="fecha"
                  render={
                ({
                  ref, value,
                }) => (
                  <DatePicker
                    className="today"
                    format="DD/MM/YYYY"
                    ref={ref}
                    value={value ? value : null}
                    disabled
                    style={{ width: '100%' }}
                  />

                )}
                  control={control}
                />
              </ReadOnly>
            </div>
          </div>
          <div className="margin-left flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.eye_chart.next_grad' })}</p>
            <div className="inputMarginTop">
              <ReadOnly condition={watch}>
                <Controller
                  name="fecha_proxima_graduacion"
                  render={
                ({
                  name, onChange, ref, value,
                }) => (
                  <DatePicker
                  disabledDate={disabledDate || watch}
                  ref={ref}
                  value={value ? value : null}
                  onChange={(e) => {
                      onChange(e);
                      setValue(name, e);
                    }}
                    disabled={watch}
                    format="DD/MM/YYYY"
                    allowClear={false}
                    placeholder="Seleccione fecha"
                    getCalendarContainer={(trigger: Element):any => (trigger.parentElement
                      ? trigger.parentElement : null)}
                    style={{ width: '100%' }}
                  />
                )}
                  control={control}
                />
              </ReadOnly>
            </div>
          </div>
        </div>
                      
        <div className="contact" style={{ paddingTop: '8px' }}>
          <div className="margin-right flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.eye_chart.attended_by' })}</p>
            <div className="inputMarginTop inputHeight" onClick={() => watch || setDrawerAttended(true)}>
              <ReadOnly condition={watch}>
                <Input
                  placeholder={intl.formatMessage({ id: 'pacientes.eye_chart.select_user' })}
                  disabled
                  value={attendedStr}
                  suffix={(
                    <FontAwesomeIcon
                      icon={faEllipsisH}
                      className="ellipsis"
                    />
                 )}
                  style={{ width: '100%' }}
                />
              </ReadOnly>
            </div>
            <div>
              {errors.atendido_por_id && (
              <p className="errors inputMarginTop">{errors.atendido_por_id.message}</p>
              )}
            </div>
          </div>
          <div className="margin-left flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.eye_chart.prescriber' })}</p>
            <div
              className="inputMarginTop inputHeight"
              onClick={() => watch || setDrawerPrescriber(true)}
            >
              <ReadOnly condition={watch}>
                <Input
                  placeholder={intl.formatMessage({ id: 'pacientes.eye_chart.select_prescriber' })}
                  disabled
                  value={prescriberStr}
                  suffix={(
                    <FontAwesomeIcon
                      icon={faEllipsisH}
                      className="ellipsis"
                    />
                )}
                  style={{ width: '100%' }}
                />
              </ReadOnly>
            </div>
            <div className="prescriptor_id_error">
              {errors.prescriptor_id && (
              <p className="errors inputMarginTop">{errors.prescriptor_id.message}</p>
              )}
            </div>
          </div>
        </div>

      </div>

      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>{intl.formatMessage({ id: 'pacientes.eye_chart.prescription' })}</h3>
          <Checkbox onChange={() => getTraspuesta()}>
            <span style={{ fontSize: '14px' }}>Traspuesta</span>
          </Checkbox>
        </div>
        <ReadOnly condition={watch}>
          <Table
            className={`marginTop16 table ${getPrescriptionErrors() ? 'table-border-error' : ''}`}
            columns={columnsPrescription}
            style={{ backgroundColor: tieneVentaAsociada ? '#F5F5F5' : 'transparent' }}
            dataSource={prescription}
            pagination={false}
          />
        </ReadOnly>
        {(errors.prescripcion && (
          <p className="errors inputMarginTop">
            {intl.formatMessage({ id: 'pacientes.eye_chart.error_prescription' })}
          </p>
        ))}
        {(tieneVentaAsociada && (
        <Flex alignItems="baseline" className="errors inputMarginTop">
          <div style={{ marginRight: '4px', lineHeight: '20px' }}>
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className="ellipsis"
              style={{ width: '16px', height: '16px', color: '#F28100' }}
              size="2x"
            />
          </div>
          <div style={{
            fontSize: '16px',
            color: '#F28100',
            lineHeight: '20px',
          }}
          >
            {intl.formatMessage({ id: 'pacientes.eyechart.venta_asociada' })}
          </div>
        </Flex>
        ))}
      </div>
      
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>{intl.formatMessage({ id: 'pacientes.eye_chart.initial_rx' })}</h3>
        </div>
        <ReadOnly condition={watch}>
          <Table className={`marginTop16 table ${getRxInitialErrors() ? 'table-border-error' : ''}`} columns={columnsRx} dataSource={initialRx} pagination={false} />
        </ReadOnly>
        {(errors.rx_inicial && (
          <p className="errors inputMarginTop">
            {intl.formatMessage({ id: 'pacientes.eye_chart.error_prescription' })}
          </p>
        ))}
      </div>

      <Flex className="bodyInfo" style={isTablet ? { flexDirection: 'column' } : { flexDirection: 'row' }}>
        <div className="flexCol margin-right">
          <div className="flexRow spaceBetween">
            <h3>{intl.formatMessage({ id: 'pacientes.eye_chart.distances' })}</h3>
          </div>
          <ReadOnly condition={watch}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%', backgroundColor: tieneVentaAsociada ? '#F5F5F5' : 'transparent' }}
              columns={columnsDistance}
              dataSource={distance}
              pagination={false}
            />
          </ReadOnly>
          {(errors.distancias && (
          <p className="errors inputMarginTop">
            {intl.formatMessage({ id: 'pacientes.generic.errors.introduce' }, {
              param: intl.formatMessage({ id: 'pacientes.generic.titles.distancias' }),
            })}
          </p>
          ))}
          {(tieneVentaAsociada && (
          <Flex alignItems="baseline" className="errors inputMarginTop">
            <div style={{ marginRight: '4px', lineHeight: '20px' }}>
              <FontAwesomeIcon
                icon={faExclamationCircle}
                className="ellipsis"
                style={{ width: '16px', height: '16px', color: '#F28100' }}
                size="2x"
              />
            </div>
            <div style={{
              fontSize: '16px',
              color: '#F28100',
              lineHeight: '20px',
            }}
            >
              {intl.formatMessage({ id: 'pacientes.eyechart.venta_asociada_distancias' })}
            </div>
          </Flex>
          ))}
        </div>
        <div className="flexCol" style={isTablet ? { marginTop: '16px' } : {}}>
          <div className="flexRow spaceBetween">
            <h3>Agudeza visual</h3>
          </div>
          <ReadOnly condition={watch}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsVisualSharp}
              dataSource={visualSharpData}
              pagination={false}
            />
          </ReadOnly>
          {(errors.agudeza_visual && (
          <p className="errors inputMarginTop">
            {intl.formatMessage({ id: 'pacientes.generic.errors.introduce' }, {
              param: intl.formatMessage({ id: 'pacientes.generic.titles.agudeza_visual' }),
            })}
          </p>
          ))}
        </div>
      </Flex>

      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Libro de prescripciones</h3>
        </div>
        <div className="contact">
          <div className="margin-right">
            <ReadOnly condition={watch}>
              <input
                className={`ant-input ${getMotivoErrors() ? 'input-border-error' : ''}`}
                type="text"
                placeholder="Motivo de visita"
                name="libro_prescripciones.motivo_visita"
                ref={cellRegister}
              />
            </ReadOnly>
          </div>
          <div className="margin-left">
            <ReadOnly condition={watch}>
              <input
                className="ant-input"
                type="text"
                placeholder="Tipo de lente prescrita"
                name="libro_prescripciones.tipo_lente_prescrita"
                ref={cellRegister}
              />
            </ReadOnly>
          </div>
        </div>
        {(errors.motivo && (
        <p className="errors inputMarginTop">{errors.motivo}</p>
        ))
      }
      </div>

      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>{intl.formatMessage({ id: 'pacientes.eye_chart.observations' })}</h3>
        </div>
        <ReadOnly condition={watch}>
          {isDesktop
            ? <textarea name="observaciones" placeholder="Escriba aquí..." ref={cellRegister} className={`${isDesktop ? 'bigHeight' : ''} ant-input marginTop16`} />
            : <input name="observaciones" placeholder="Escriba aquí..." ref={cellRegister} className="ant-input marginTop16" />
          }
        </ReadOnly>
      </div>
    </>
  );
}
export default injectIntl(EyeChartContent);
